module.exports = {
  dark: {
    "loading-shimmer": "primary-500",
    "loading-shimmer-button": "primary-600",
    "member-wifi-status-content": "primary-900",
    "member-wifi-status-details-container": "primary-350",
    "member-wifi-status-icon": "success-600",
    "member-wifi-status-passenger-icon": "primary-900",
    "member-wifi-status-passenger-name": "primary-900",
    "member-wifi-status-wifi-icon": "primary-900",
  },
  light: {
    "loading-shimmer": "neutral-500",
    "loading-shimmer-button": "neutral-600",
    "member-wifi-status-content": "neutral-900",
    "member-wifi-status-details-container": "primary-350",
    "member-wifi-status-icon": "success-600",
    "member-wifi-status-passenger-icon": "neutral-900",
    "member-wifi-status-passenger-name": "neutral-900",
    "member-wifi-status-wifi-icon": "neutral-900",
  },
};
